export const SERP_TRAFFIC_DISTRIBUTION_API = "api/WebsiteAnalysis/Overview/SerpDistribution";
export const SERP_TRAFFIC_DISTRIBUTION_QUERY_KEY = "seo-verview-serp-traffic-distribution";
